import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Box } from "@mui/system";
import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import { updateElement } from "../../database/API";
import theme from "../../theme";
import CustomTextField from "./CustomTextField";
import CustomButton from "../CustomButton";
import CustomButtonAdmin from "./CustomButtonAdmin";

function DialogEditClient({ setUpdate, open, setOpen, id, label, name, value }) {
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const { handleSubmit, register } = useForm();

    const handleClose = () => {
        setOpen(false);
    };

    const editar = async (values) => {
        setLoading(true);
        await updateElement("reserves", values, id);
        enqueueSnackbar("Actualitzat", {
            variant: "success",
        });
        setUpdate((prev) => prev + 1);
        setOpen(false);
        setLoading(false);
    };

    return (
        <Dialog
            onClose={handleClose}
            open={open}
            PaperProps={{
                style: {
                    borderRadius: 0,
                    width: 400,
                },
            }}
            maxWidth="lg"
        >
            <DialogTitle sx={{ background: theme.color.primary, color: "white" }}>
                <Box display="flex" justifyContent={"space-between"}>
                    Editar {label}
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box my={3}>
                    <form onSubmit={handleSubmit(editar)}>
                        <CustomTextField register={register} name={name} label={label} defaultValue={value} />
                        <Box my={2} />
                        <CustomButtonAdmin title={"Guardar"} fullWidth loading={loading} type="submit" />
                    </form>
                </Box>
            </DialogContent>
        </Dialog>
    );
}

export default DialogEditClient;
